function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M486.912,397.456V402.7l3.48,3.48a.956.956,0,0,1-1.352,1.352l-3.76-3.76a.956.956,0,0,1-.28-.676v-5.64a.956.956,0,1,1,1.912,0Z",
  transform: "translate(-473.721 -390.86)",
  fill: "#00abff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M324,308h-7.52a8.447,8.447,0,0,0-5.558,2.078v-1.122a.956.956,0,1,0-1.912,0v3.76a.958.958,0,0,0,.956.956h3.76a.956.956,0,1,0,0-1.912h-1.808a6.585,6.585,0,0,1,4.562-1.848H324a6.571,6.571,0,0,1,6.564,6.564V324A6.571,6.571,0,0,1,324,330.559h-7.52A6.571,6.571,0,0,1,309.912,324v-3.76a.956.956,0,1,0-1.912,0V324a8.485,8.485,0,0,0,8.476,8.476H324A8.485,8.485,0,0,0,332.471,324v-7.52A8.485,8.485,0,0,0,324,308Z",
  transform: "translate(-308 -308)",
  fill: "#0078d7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559,308",
  transform: "translate(-543.005 -308)"
}));

function SvgHoursIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.471,
    height: 24.471,
    viewBox: "0 0 24.471 24.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursIcon);
export default __webpack_public_path__ + "static/media/hours-icon.e126e3db.svg";
export { ForwardRef as ReactComponent };